// src/pages/MeetTheDoctorHome.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const MeetTheDoctorHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const specializationMaster = [
    {
      id: "cardiologist",
      label: "Cardiologist",
      aliases: ["Heart Doctor", "Heart Specialist"],
      category: "Super Specialty",
      icon: "❤️",
    },
    {
      id: "dermatologist",
      label: "Dermatologist",
      aliases: ["Skin Doctor"],
      category: "Specialty",
      icon: "🧴",
    },
    {
      id: "diabetologist",
      label: "Diabetologist",
      aliases: ["Diabetes Doctor"],
      category: "Specialty",
      icon: "🩸",
    },
    {
      id: "ent",
      label: "ENT Specialist",
      aliases: ["Ear Nose Throat Doctor"],
      category: "Specialty",
      icon: "👂",
    },
    {
      id: "gastroenterologist",
      label: "Gastroenterologist",
      aliases: ["Stomach Doctor"],
      category: "Super Specialty",
      icon: "🍽️",
    },
    {
      id: "general-physician",
      label: "General Physician",
      aliases: ["Family Doctor", "GP"],
      category: "Primary Care",
      icon: "🩺",
    },
    {
      id: "gynecologist",
      label: "Gynecologist",
      aliases: ["Women Doctor"],
      category: "Specialty",
      icon: "🤰",
    },
    {
      id: "neurologist",
      label: "Neurologist",
      aliases: ["Brain Doctor"],
      category: "Super Specialty",
      icon: "🧠",
    },
    {
      id: "nephrologist",
      label: "Nephrologist",
      aliases: ["Kidney Doctor"],
      category: "Super Specialty",
      icon: "💧",
    },
    {
      id: "oncologist",
      label: "Oncologist",
      aliases: ["Cancer Doctor"],
      category: "Super Specialty",
      icon: "🎗️",
    },
    {
      id: "ophthalmologist",
      label: "Ophthalmologist",
      aliases: ["Eye Doctor"],
      category: "Specialty",
      icon: "👁️",
    },
    {
      id: "orthopedic",
      label: "Orthopedic Surgeon",
      aliases: ["Bone Doctor"],
      category: "Surgical",
      icon: "🦴",
    },
    {
      id: "pediatrician",
      label: "Pediatrician",
      aliases: ["Child Doctor"],
      category: "Specialty",
      icon: "👶",
    },
    {
      id: "psychiatrist",
      label: "Psychiatrist",
      aliases: ["Mental Health Doctor"],
      category: "Specialty",
      icon: "🧠",
    },
    {
      id: "pulmonologist",
      label: "Pulmonologist",
      aliases: ["Lung Doctor"],
      category: "Super Specialty",
      icon: "🫁",
    },
    {
      id: "radiologist",
      label: "Radiologist",
      aliases: ["Scan Doctor"],
      category: "Diagnostic",
      icon: "🩻",
    },
    {
      id: "urologist",
      label: "Urologist",
      aliases: ["Urine Doctor"],
      category: "Super Specialty",
      icon: "🚽",
    },
    {
      id: "vascular-surgeon",
      label: "Vascular Surgeon",
      aliases: ["Blood Vessel Surgeon"],
      category: "Surgical",
      icon: "🩸",
    },
  ];

  const degreeMaster = {
    MBBS: "Bachelor of Medicine, Bachelor of Surgery",
    MD: "Doctor of Medicine",
    MS: "Master of Surgery",
    DM: "Doctorate of Medicine (Super Specialty)",
    MCh: "Master of Chirurgiae (Super Specialty)",
    DNB: "Diplomate of National Board",
  };


  const dummyDoctors = [
    {
      id: 1,
      name: "Dr. Ayesha Khan",
      specialization: "Cardiologist",
      registrationNumber: "MCI-456789",
      rating: 4.6,
      details:
        "Senior cardiologist with 12+ years of experience in interventional cardiology.",
      locations: [
        {
          establishmentType: "Clinic",
          address: "12 Park View Road",
          neighborhood: "Andheri West",
          city: "Mumbai",
          state: "Maharashtra",
          pin: "400053",
          timing: "10:00 AM – 2:00 PM",
          open: true,
        },
        {
          establishmentType: "Hospital",
          address: "City Heart Hospital",
          neighborhood: "Bandra East",
          city: "Mumbai",
          state: "Maharashtra",
          pin: "400051",
          timing: "5:00 PM – 8:00 PM",
          open: false,
        },
      ],
    },
    {
      id: 2,
      name: "Dr. Rohan Mehta",
      specialization: "Orthopedic Surgeon",
      registrationNumber: "MCI-998877",
      rating: 4.3,
      details:
        "Specialist in sports injuries and joint replacement surgeries.",
      locations: [
        {
          establishmentType: "Clinic",
          address: "45 Green Avenue",
          neighborhood: "Indiranagar",
          city: "Bengaluru",
          state: "Karnataka",
          pin: "560038",
          timing: "9:00 AM – 1:00 PM",
          open: true,
        },
      ],
    },
    {
      id: 3,
      name: "Dr. Aarushi Patil",
      degree: "MBBS, MD (Cardiology)",
      specialization: "Cardiologist",
      registrationNumber: "MCI-456339",
      rating: 4.6,
      details:
        "Senior cardiologist with 18+ years of experience in interventional cardiology.",
      locations: [
        {
          establishmentType: "Clinic",
          address: "1, Lodha Heaven",
          neighborhood: "Palava",
          city: "Thane",
          state: "Maharashtra",
          pin: "421204",
          timing: "10:00 AM – 2:00 PM",
          open: true,
        },
      ],
    },
    {
      id: 4,
      name: "Dr. Sushil Athawale",
      degree: "MBBS",
      specialization: "General Physician",
      registrationNumber: "MCI-668899",
      rating: 4.3,
      details:
        "Specialist in general medicinies.",
      locations: [
        {
          establishmentType: "Clinic",
          address: "45 Green Avenue, Lakeshore",
          neighborhood: "Palava",
          city: "Dombivali",
          state: "Maharashtra",
          pin: "421203",
          timing: "9:00 AM – 1:00 PM",
          open: true,
        },
      ],
    },
    {
      id: 5,
      name: "Dr. Neha Sharma",
      degree: "MBBS, MD (Dermatology)",
      specialization: "Dermatologist",
      registrationNumber: "MCI-112233",
      rating: 4.5,
      details: "Expert in acne, pigmentation, and cosmetic dermatology.",
      locations: [
        {
          establishmentType: "Clinic",
          address: "SkinCare Plaza",
          neighborhood: "DLF Phase 3",
          city: "Gurugram",
          state: "Haryana",
          pin: "122010",
          timing: "11:00 AM – 4:00 PM",
          open: true,
        },
      ],
    },

    {
      id: 6,
      name: "Dr. Suresh Iyer",
      degree: "MBBS, MD (General Medicine)",
      specialization: "General Physician",
      registrationNumber: "MCI-334455",
      rating: 4.2,
      details: "Family physician treating acute and chronic illnesses.",
      locations: [
        {
          establishmentType: "Clinic",
          address: "Lake View Street",
          neighborhood: "Adyar",
          city: "Chennai",
          state: "Tamil Nadu",
          pin: "600020",
          timing: "8:00 AM – 12:00 PM",
          open: true,
        },
      ],
    },

    {
      id: 7,
      name: "Dr. Pooja Verma",
      degree: "MBBS, MS (Obstetrics & Gynecology)",
      specialization: "Gynecologist",
      registrationNumber: "MCI-556677",
      rating: 4.7,
      details: "High-risk pregnancy and infertility specialist.",
      locations: [
        {
          establishmentType: "Hospital",
          address: "MotherCare Hospital",
          neighborhood: "Alambagh",
          city: "Lucknow",
          state: "Uttar Pradesh",
          pin: "226005",
          timing: "10:00 AM – 3:00 PM",
          open: true,
        },
      ],
    },

    {
      id: 8,
      name: "Dr. Arjun Patel",
      degree: "MBBS, DM (Neurology)",
      specialization: "Neurologist",
      registrationNumber: "MCI-778899",
      rating: 4.4,
      details: "Treats epilepsy, stroke, and neurodegenerative disorders.",
      locations: [
        {
          establishmentType: "Hospital",
          address: "NeuroCare Center",
          neighborhood: "Navrangpura",
          city: "Ahmedabad",
          state: "Gujarat",
          pin: "380009",
          timing: "2:00 PM – 7:00 PM",
          open: false,
        },
      ],
    },
    {
      id: 9,
      name: "Dr. Ritu Malhotra",
      degree: "MBBS, MD (Pediatrics)",
      specialization: "Pediatrician",
      registrationNumber: "MCI-889900",
      rating: 4.8,
      details: "Child health, vaccinations, and newborn care.",
      locations: [
        {
          establishmentType: "Clinic",
          address: "Happy Kids Clinic",
          neighborhood: "Rohini",
          city: "Delhi",
          state: "Delhi",
          pin: "110085",
          timing: "9:00 AM – 1:00 PM",
          open: true,
        },
      ],
    },
    {
      id: 10,
      name: "Dr. Imran Siddiqui",
      degree: "MBBS, MD (Pulmonology)",
      specialization: "Pulmonologist",
      registrationNumber: "MCI-667788",
      rating: 4.1,
      details: "Asthma, COPD, and respiratory critical care.",
      locations: [
        {
          establishmentType: "Hospital",
          address: "Chest Care Institute",
          neighborhood: "Charminar",
          city: "Hyderabad",
          state: "Telangana",
          pin: "500002",
          timing: "11:00 AM – 5:00 PM",
          open: true,
        },
      ],
    },

    {
      id: 11,
      name: "Dr. Kavita Joshi",
      degree: "MBBS, MD (Psychiatry)",
      specialization: "Psychiatrist",
      registrationNumber: "MCI-443322",
      rating: 4.6,
      details: "Mental health, anxiety, depression, and stress disorders.",
      locations: [
        {
          establishmentType: "Clinic",
          address: "Mind Wellness Center",
          neighborhood: "Aundh",
          city: "Pune",
          state: "Maharashtra",
          pin: "411007",
          timing: "4:00 PM – 8:00 PM",
          open: true,
        },
      ],
    },
    {
      id: 12,
      name: "Dr. Sanjay Rao",
      degree: "MBBS, MD (Radiology)",
      specialization: "Radiologist",
      registrationNumber: "MCI-221144",
      rating: 4.0,
      details: "MRI, CT Scan, and diagnostic imaging expert.",
      locations: [
        {
          establishmentType: "Diagnostic Center",
          address: "ScanPlus Diagnostics",
          neighborhood: "Whitefield",
          city: "Bengaluru",
          state: "Karnataka",
          pin: "560066",
          timing: "9:00 AM – 6:00 PM",
          open: true,
        },
      ],
    },
    {
      id: 13,
      name: "Dr. Anil Deshpande",
      degree: "MBBS, MD (Endocrinology)",
      specialization: "Diabetologist",
      registrationNumber: "MCI-554433",
      rating: 4.4,
      details: "Diabetes, thyroid disorders, and metabolic diseases specialist.",
      locations: [
        {
          establishmentType: "Clinic",
          address: "Health First Clinic",
          neighborhood: "Kothrud",
          city: "Pune",
          state: "Maharashtra",
          pin: "411038",
          timing: "7:00 AM – 11:00 AM",
          open: true,
        },
      ],
    },

    {
      id: 14,
      name: "Dr. Meenal Kulkarni",
      degree: "MBBS, MS (ENT)",
      specialization: "ENT Specialist",
      registrationNumber: "MCI-667744",
      rating: 4.3,
      details: "Ear, nose, throat disorders and sinus surgery specialist.",
      locations: [
        {
          establishmentType: "Clinic",
          address: "HearWell ENT Care",
          neighborhood: "Karve Nagar",
          city: "Pune",
          state: "Maharashtra",
          pin: "411052",
          timing: "10:00 AM – 2:00 PM",
          open: true,
        },
      ],
    },

    {
      id: 15,
      name: "Dr. Rajiv Malhotra",
      degree: "MBBS, DM (Gastroenterology)",
      specialization: "Gastroenterologist",
      registrationNumber: "MCI-998811",
      rating: 4.5,
      details: "Liver, pancreas, and digestive system disorders specialist.",
      locations: [
        {
          establishmentType: "Hospital",
          address: "Digestive Care Hospital",
          neighborhood: "Rajouri Garden",
          city: "Delhi",
          state: "Delhi",
          pin: "110027",
          timing: "12:00 PM – 6:00 PM",
          open: false,
        },
      ],
    },
    {
      id: 16,
      name: "Dr. Sunita Nair",
      degree: "MBBS, MS (Ophthalmology)",
      specialization: "Ophthalmologist",
      registrationNumber: "MCI-334466",
      rating: 4.6,
      details: "Cataract, glaucoma, and LASIK eye surgery expert.",
      locations: [
        {
          establishmentType: "Eye Hospital",
          address: "VisionPlus Eye Center",
          neighborhood: "Vyttila",
          city: "Kochi",
          state: "Kerala",
          pin: "682019",
          timing: "9:30 AM – 4:30 PM",
          open: true,
        },
      ],
    },
    {
      id: 17,
      name: "Dr. Prakash Menon",
      degree: "MBBS, DM (Nephrology)",
      specialization: "Nephrologist",
      registrationNumber: "MCI-221199",
      rating: 4.2,
      details: "Kidney diseases, dialysis, and transplant care.",
      locations: [
        {
          establishmentType: "Hospital",
          address: "Renal Care Institute",
          neighborhood: "Palarivattom",
          city: "Kochi",
          state: "Kerala",
          pin: "682025",
          timing: "11:00 AM – 3:00 PM",
          open: true,
        },
      ],
    },
    {
      id: 18,
      name: "Dr. Vinayak Joshi",
      degree: "MBBS, MCh (Urology)",
      specialization: "Urologist",
      registrationNumber: "MCI-889977",
      rating: 4.4,
      details: "Urinary tract, prostate, and kidney stone specialist.",
      locations: [
        {
          establishmentType: "Hospital",
          address: "UroLife Hospital",
          neighborhood: "Banashankari",
          city: "Bengaluru",
          state: "Karnataka",
          pin: "560070",
          timing: "2:00 PM – 7:00 PM",
          open: false,
        },
      ],
    },
    {
      id: 19,
      name: "Dr. Shalini Kapoor",
      degree: "MBBS, MD (Oncology)",
      specialization: "Oncologist",
      registrationNumber: "MCI-556688",
      rating: 4.7,
      details: "Medical oncology and chemotherapy specialist.",
      locations: [
        {
          establishmentType: "Cancer Hospital",
          address: "Hope Cancer Institute",
          neighborhood: "Sector 62",
          city: "Noida",
          state: "Uttar Pradesh",
          pin: "201309",
          timing: "10:00 AM – 4:00 PM",
          open: true,
        },
      ],
    },
    {
      id: 20,
      name: "Dr. Abhishek Chatterjee",
      degree: "MBBS, MS (General Surgery)",
      specialization: "General Surgeon",
      registrationNumber: "MCI-773344",
      rating: 4.1,
      details: "Laparoscopic and minimally invasive surgeries.",
      locations: [
        {
          establishmentType: "Hospital",
          address: "City Surgical Center",
          neighborhood: "Salt Lake",
          city: "Kolkata",
          state: "West Bengal",
          pin: "700091",
          timing: "1:00 PM – 6:00 PM",
          open: true,
        },
      ],
    },
    {
      id: 21,
      name: "Dr. Nikhil Bansal",
      degree: "MBBS, MD (Internal Medicine)",
      specialization: "Internal Medicine Specialist",
      registrationNumber: "MCI-664422",
      rating: 4.3,
      details: "Chronic disease management and preventive medicine.",
      locations: [
        {
          establishmentType: "Clinic",
          address: "Prime Health Clinic",
          neighborhood: "Model Town",
          city: "Jaipur",
          state: "Rajasthan",
          pin: "302017",
          timing: "8:30 AM – 12:30 PM",
          open: true,
        },
      ],
    },
    {
      id: 22,
      name: "Dr. Farah Ali",
      degree: "MBBS, MD (Pulmonology)",
      specialization: "Pulmonologist",
      registrationNumber: "MCI-998833",
      rating: 4.5,
      details: "Tuberculosis, asthma, and sleep apnea specialist.",
      locations: [
        {
          establishmentType: "Hospital",
          address: "Respira Care Hospital",
          neighborhood: "Aliganj",
          city: "Lucknow",
          state: "Uttar Pradesh",
          pin: "226024",
          timing: "3:00 PM – 8:00 PM",
          open: true,
        },
      ],
    },
    {
      id: 23,
      name: "Dr. Karthik Reddy",
      degree: "MBBS, MS (Orthopedics)",
      specialization: "Orthopedic Surgeon",
      registrationNumber: "MCI-445566",
      rating: 4.2,
      details: "Spine care, fracture management, and joint pain.",
      locations: [
        {
          establishmentType: "Clinic",
          address: "Bone & Joint Clinic",
          neighborhood: "Madhapur",
          city: "Hyderabad",
          state: "Telangana",
          pin: "500081",
          timing: "6:00 PM – 9:00 PM",
          open: false,
        },
      ],
    },
    {
      id: 24,
      name: "Dr. Sneha Banerjee",
      degree: "MBBS, MD (Radiodiagnosis)",
      specialization: "Radiologist",
      registrationNumber: "MCI-332211",
      rating: 4.4,
      details: "Ultrasound, CT, MRI, and diagnostic imaging.",
      locations: [
        {
          establishmentType: "Diagnostic Center",
          address: "ImagePro Diagnostics",
          neighborhood: "Behala",
          city: "Kolkata",
          state: "West Bengal",
          pin: "700034",
          timing: "9:00 AM – 5:00 PM",
          open: true,
        },
      ],
    },
  ];


  const [query, setQuery] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [filteredDoctors, setFilteredDoctors] = useState(dummyDoctors);

  const handleSearch = () => {
    const q = query.toLowerCase();
    setFilteredDoctors(
      dummyDoctors.filter(
        (doc) =>
          doc.name.toLowerCase().includes(q) ||
          doc.specialization.toLowerCase().includes(q) ||
          doc.locations.some(
            (loc) =>
              loc.neighborhood.toLowerCase().includes(q) ||
              loc.city.toLowerCase().includes(q) ||
              loc.pin.includes(q)
          )
      )
    );
  };

  if (selectedDoctor) {
    return (
      <section className="px-2 py-2 mx-auto space-y-4">
        <button
          onClick={() => setSelectedDoctor(null)}
          className="text-sm text-blue-500"
        >
          ← Back to search
        </button>

        <h2 className="text-2xl font-bold text-yellow-200">
          🩺 {selectedDoctor.name}
        </h2>

        <p className="text-white">
          {selectedDoctor.specialization}
        </p>

        <p className="text-sm text-white">
          <strong>Registration:</strong>{" "}
          {selectedDoctor.registrationNumber}
        </p>

        <p className="text-sm text-white">{selectedDoctor.details}</p>

        <div className="space-y-3">
          {selectedDoctor.locations.map((loc, idx) => (
            <div
              key={idx}
              className="border rounded-xl p-3 space-y-1 shadow-sm"
            >
              <p className="font-semibold text-white">
                🏥 {loc.establishmentType}
              </p>
              <p className="text-sm text-white">{loc.address}</p>
              <p className="text-sm text-white">
                {loc.neighborhood}, {loc.city}, {loc.state} –{" "}
                {loc.pin}
              </p>
              <p className="text-sm text-white">
                ⏰ {loc.timing}
              </p>
              <p
                className={`text-sm font-medium ${
                  loc.open ? "text-green-500" : "text-red-600"
                }`}
              >
                {loc.open ? "🟢 Open Now" : "🔴 Closed"}
              </p>

              <div className="grid grid-cols-6 gap-2 place-items-center">
                <button className="flex items-center justify-center w-12 h-12 bg-blue-500 text-white text-lg rounded-lg shadow-sm hover:shadow-md transition">
                  📍
                </button>
                <button className="flex items-center justify-center w-12 h-12 bg-green-500 text-white text-lg rounded-lg shadow-sm hover:shadow-md transition">
                  📅
                </button>
                <button className="flex items-center justify-center w-12 h-12 bg-gray-500 text-white text-lg rounded-lg shadow-sm hover:shadow-md transition">
                  🔢
                </button>
                <button className="flex items-center justify-center w-12 h-12 bg-green-500 text-white text-lg rounded-lg shadow-sm hover:shadow-md transition">
                  📄
                </button>
                <button className="flex items-center justify-center w-12 h-12 bg-blue-500 text-white text-lg rounded-lg shadow-sm hover:shadow-md transition">
                  🔊
                </button>
                <button className="flex items-center justify-center w-12 h-12 bg-green-500 text-white text-lg rounded-lg shadow-sm hover:shadow-md transition">
                  📢
                </button>
              </div>

            </div>
          ))}
        </div>
      </section>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-gray-800 px-4 py-1 flex items-center justify-between">
        <div className="flex flex-col">
          {/* <div className="text-lg lg:text-xl font-bold text-yellow-200">MeetTheDoctor</div> */}
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-18 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}

      <section className="flex-grow mx-auto px-3 py-6 w-full text-center">
        {/* Title */}
        <h1 className="text-3xl sm:text-4xl font-extrabold mb-2">
          🩺 MeetTheDoctor
        </h1>

        {/* Search */}
        <div className="flex items-center max-w-xl mx-auto mb-2 px-3 py-2 shadow-sm">
          <input
            type="text"
            placeholder="Search doctor, area, specialization, PIN"
            className="flex-grow outline-none text-sm px-2 h-10 border rounded-full text-black"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button
            onClick={handleSearch}
            className="text-blue-500 text-lg px-2 w-10"
          >
            <i className="fas fa-search"></i>
          </button>
        </div>

        {/* Quick Actions */}
        <div className="mx-auto mb-2">
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-1 text-xs lg:text-xs place-items-center">

            <button className="flex flex-col items-center justify-center gap-1 p-3 rounded-xl border shadow-sm hover:shadow-md transition bg-gray-700">
              
              <span className="text-center font-medium text-xs">
                🩺 2nd Opinion
              </span>
            </button>

            <button className="flex flex-col items-center justify-center gap-1 p-3 rounded-xl border shadow-sm hover:shadow-md transition bg-gray-700">
              
              <span className="text-center font-medium text-xs">
                📁 Health Records
              </span>
            </button>

            <button className="flex flex-col items-center justify-center gap-1 p-3 rounded-xl border shadow-sm hover:shadow-md transition bg-gray-700">
              
              <span className="text-center font-medium text-xs">
                📤 Upload Reports
              </span>
            </button>

            <button className="flex flex-col items-center justify-center gap-1 p-3 rounded-xl border shadow-sm hover:shadow-md transition bg-gray-700">
              
              <span className="text-center font-medium text-xs">
                🎙️ Record Like Talking to Doctor
              </span>
            </button>

            <button className="flex flex-col items-center justify-center gap-1 p-3 rounded-xl border shadow-sm hover:shadow-md transition bg-gray-700">
              
              <span className="text-center font-medium text-xs">
                🌿 Alternate Meds
              </span>
            </button>

            <button className="flex flex-col items-center justify-center gap-1 p-3 rounded-xl border shadow-sm hover:shadow-md transition bg-gray-700">
              
              <span className="text-center font-medium text-xs">
                🦶 Podiatry
              </span>
            </button>

            <button className="flex flex-col items-center justify-center gap-1 p-3 rounded-xl border shadow-sm hover:shadow-md transition bg-gray-700">
              
              <span className="text-center font-medium text-xs">
                🧿 Vision/Eye
              </span>
            </button>                        

            <button className="flex flex-col items-center justify-center gap-1 p-3 rounded-xl border shadow-sm hover:shadow-md transition bg-gray-700">
              
              <span className="text-center font-medium text-xs">
                💊 Medicine Nearby
              </span>
            </button>

            <button className="flex flex-col items-center justify-center gap-1 p-3 rounded-xl border shadow-sm hover:shadow-md transition bg-gray-700">
              
              <span className="text-center font-medium text-xs">
                📋 Specializations
              </span>
            </button>

            <button className="flex flex-col items-center justify-center gap-1 p-3 rounded-xl border shadow-sm hover:shadow-md transition bg-gray-700">
              
              <span className="text-center font-medium text-xs">
                🤖 Responsible AI Counselling
              </span>
            </button>
          </div>
        </div>

        {/* Doctor List */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 text-left">
          {filteredDoctors.map((doc) => (
            <div
              key={doc.id}
              onClick={() => setSelectedDoctor(doc)}
              className="border rounded-xl p-4 shadow-sm cursor-pointer hover:shadow-md transition"
            >
              <h3 className="text-sm lg:text-lg font-semibold text-yellow-200">
                {doc.name}
              </h3>
              <p className="text-xs lg:text-sm text-white">
                {doc.specialization}
              </p>

              <p className="text-xs lg:text-sm mt-1 text-white">
                ⭐ {doc.rating}
              </p>

              <p
                className={`text-xs lg:text-sm mt-1 ${
                  doc.locations[0].open
                    ? "text-green-600"
                    : "text-red-500"
                }`}
              >
                {doc.locations[0].open ? "🟢 Open Now" : "🔴 Closed"}
              </p>

              <div className="mt-2 flex flex-row gap-1">
                <button className="text-xs lg:text-sm bg-blue-500 text-yellow-200 w-8 lg:w-12 px-1">
                  ℹ️
                </button>
                <button className="text-xs lg:text-sm bg-blue-500 text-yellow-200 w-8 lg:w-12 px-1">
                  💬
                </button>
                <button className="text-xs lg:text-sm bg-blue-500 text-yellow-200 w-8 lg:w-12 px-1">
                  📞
                </button>    
                <button className="text-xs lg:text-sm bg-blue-500 text-yellow-200 w-8 lg:w-12 px-1">
                  📍
                </button>                                               
              </div>
            </div>
          ))}
        </div>
      </section>

      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MeetTheDoctorHome;
